export const MOSCOW_TIME_ZONE_LABEL = 'UTC+3';
export const MOSCOW_TIME_ZONE_OFFSET = '+03:00';

const MOSCOW_OFFSET_MILLISECONDS = 3 * 60 * 60 * 1000;

export type DateTimeValue = string | number | Date | null | undefined;

export function moscowWallTime(value: DateTimeValue): string | null {
  if (value === null || value === undefined || value === '') return null;
  const instant =
    value instanceof Date ? value.getTime() : new Date(value).getTime();
  if (!Number.isFinite(instant)) return null;
  return new Date(instant + MOSCOW_OFFSET_MILLISECONDS)
    .toISOString()
    .slice(0, -1);
}

export function moscowDateTime(value: DateTimeValue): string {
  const wallTime = moscowWallTime(value);
  if (!wallTime) return '';
  return `${wallTime.slice(8, 10)}.${wallTime.slice(5, 7)}.${wallTime.slice(0, 4)} ${wallTime.slice(11, 19)}`;
}
